import { render, staticRenderFns } from "./VideoBg.vue?vue&type=template&id=3d7121d2"
import script from "./VideoBg.vue?vue&type=script&lang=js"
export * from "./VideoBg.vue?vue&type=script&lang=js"
import style0 from "./VideoBg.vue?vue&type=style&index=0&id=3d7121d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports